import React from 'react';
import { observer } from 'mobx-react';
import Text from '../../../../../../../global/text/text';
import { DateFnsFormats, IDateTimeFormatter } from '../../../../../../../../infrastructure/date-formatter';
import { OERadioSingleOption } from '../../../../../../../global/oe-radio-options/oe-radio-single-option';
import { IMeetingDetailsDTO } from '../../../../../../../../api/meetings.dao';

type Props = {
    item: IMeetingDetailsDTO;
    isSelected: boolean;
    setMeetingId: (meetingId: number) => void;
    timezone: string;
    dateTimeFormatter: IDateTimeFormatter;
};

export const ScheduledMeetingEventListItem = observer((props: Props): JSX.Element => {
    const { item, isSelected, setMeetingId, timezone, dateTimeFormatter } = props;

    const meetingDateTime = dateTimeFormatter.dateToFormattedString(new Date(item.startDateTime), DateFnsFormats.StringifiedMonthDayYearTime, timezone);
    const presenters = item.presenters?.map(x => x.name).join(', ');

    return (
        <tr className='hoverable'>
            <td>
                <OERadioSingleOption
                    value={item.meetingId}
                    checked={isSelected}
                    onToggle={setMeetingId.bind(null, item.meetingId)}
                />
            </td>
            <Text tag='td' message={meetingDateTime} />
            <Text tag='td' message={item.topic} withEllipsis />
            <Text tag='td' message={presenters} withEllipsis />
            <Text tag='td' message={item.type} withEllipsis />
            <Text tag='td' message={item.track} withEllipsis />
        </tr>
    );
});
